export default "/assets/images/chart-sm-03.22b10ffede8a58df.svg";